import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import ContentfulButton from '../Utilities/Buttons/ContentfulButton'

function LoanCardV2({ data }) {
  const {
    /* cardOnly, primary, secureLoans, */
    images,
    headline,
    subText,
    buttons,
    afterText
  } = data

  let topClass = 'loan-card new'
  // if (cardOnly)
  topClass += '' // ' loan-card--sub'

  let contentClass = 'loan-card__content-box'
  // if (cardOnly)
  contentClass += '' // ' loan-card__content-box--card-only'

  let buttonGroupClass = 'loan-card__button-box'
  // if (secureLoans || primary)
  buttonGroupClass += '' // ' loan-card__button-box--child'

  const buttonGroup = !buttons ? null : (
    <div className={buttonGroupClass}>
      {buttons &&
        buttons.map((button, index) => (
          /* eslint-disable react/no-array-index-key */
          <ContentfulButton data={button} key={index} />
        ))}
    </div>
  )

  const text1 = buttonGroup ? subText?.subText : (subText?.subText || '') + afterText

  let heading = <h4 className="loan-card__heading">{headline}</h4>
  if (buttons && buttons[1] && buttons[1].text === 'Learn More') {
    const learnMore = buttons[1]
    heading = (
      <Link
        to={learnMore.url}
        className="loan-card__heading-link"
        data-event={learnMore.dataEvent}
        // onClick={() => this.handleWindowReload(url)}
      >
        {heading}
      </Link>
    )
  }

  return (
    <div className={topClass}>
      {images?.length && (
        <GatsbyImage
          className="loan-card__img"
          image={getImage(images[0].image)}
          alt={images[0]?.altText}
        />
      )}
      <div className={contentClass}>
        {heading}
        <p className="loan-card__text">{text1}</p>
      </div>
      {buttonGroup}
    </div>
  )
}

LoanCardV2.propTypes = {
  data: PropTypes.object.isRequired
}

export default LoanCardV2
